import React from 'react';
import PropTypes from 'prop-types';
import CompanyAutocomplete from './CompanyAutocomplete';
import { DatePicker } from 'material-ui';
import DateFormatter from '../utils/DateFormatter';
import DateUtils from '../utils/DateUtils';

export default class FormField extends React.Component {

    datePickerDialog;

    setDatePickerDialogReference(ref) {
        this.datePickerDialog = ref;
    }

    openDatePicker() {
        this.datePickerDialog.refs.dialogWindow.show();
    }

    renderField(field) {
        const { testId, meta: { touched, error } } = field;
        const formLineClassName = `form-line ${touched && error ? 'focused error' : ''}`;

        switch ( field.type ) {
            case 'hidden':
                return (
                    <div>
                        <input
                            id={field.name}
                            type={field.type}
                            {...field.input}
                            disabled={field.disabled || false}
                            readOnly={field.readOnly || false}
                        />
                    </div>
                );
            case 'date':
                let DateTimeFormat = global.Intl.DateTimeFormat;
                return (
                    <div className={'form-group'}>
                        <label htmlFor="">{field.label}</label>
                        <div className="row">
                            <div className="col-xs-10">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="DD/MM/AAAA"
                                    id={field.name}
                                    {...field.input}
                                    value={DateFormatter.tryFormatDate(field.input.value)}
                                    disabled={field.disabled || false}
                                    readOnly={field.readOnly || false}
                                    onChange={(event) => {
                                        const dateString = DateUtils.formatDateString(event.target.value);
                                        field.input.onChange(dateString);
                                    }}
                                />
                            </div>
                            <div className="col-xs-2 text-right">
                                {
                                    field.disabled || false ? null : (
                                        <a className="dtp-launcher" onClick={() => this.openDatePicker()}>
                                            <i className="material-icons">date_range</i>
                                        </a>
                                    )
                                }
                            </div>
                        </div>
                        <div className="input-border"/>
                        <DatePicker
                            ref={r => this.setDatePickerDialogReference(r)}
                            className={'hide'}
                            DateTimeFormat={DateTimeFormat}
                            formatDate={(date) => {
                                return DateFormatter.formatDate(date);
                            }}
                            onChange={(_, date) => {
                                const newDate = DateUtils.buildDate(date);
                                field.input.onChange(DateFormatter.tryFormatDate(newDate));
                            }}
                            value={DateUtils.isValidDate(field.input.value) ? DateUtils.buildDateFromString(field.input.value) : null}
                            disabled={field.disabled || false}
                            locale="es-ES"
                        />
                        <label className="error">{touched ? error : ''}</label>
                    </div>
                );
            case 'textarea':
                const textAreaClassName = 'form-control no-resize ' + field.textAreaClassName;
                return (
                    <div className={'form-group ' + field.formGroupClassName}>
                        <div className={formLineClassName}>
                            <label htmlFor={field.name}>{field.label}</label>
                            <textarea
                                test-id={testId}
                                id={field.name}
                                rows={field.rows}
                                className={textAreaClassName}
                                {...field.input}
                                disabled={field.disabled || false}
                                placeholder={field.placeholder}
                            />
                        </div>
                        <label className="error">{touched ? error : ''}</label>
                    </div>
                );
            case 'checkbox':
                return (
                    <div className="switch-box">
                        <label htmlFor="contact-person">{field.label}</label>
                        <div className="switch">
                            <label>
                                {field.labelDisabled}
                                <input
                                    type="checkbox"
                                    disabled={field.disabled || false}
                                    {...field.input}
                                />
                                <span className="lever switch-col-blue-grey"></span>
                                {field.labelEnabled}
                            </label>
                        </div>
                        <label className="error">{touched ? error : ''}</label>
                    </div>
                );
            case 'selectSimple':
                const selectClassName = 'form-control show-tick bootstrap-select' + ( touched && error ? ' bootstrap-select-error' : '' );
                return (
                    <div className="form-group">
                        <label htmlFor={field.name}>{field.label}</label>
                        <select
                            className={selectClassName}
                            id={field.name}
                            {...field.input}
                            disabled={field.disabled || false}
                        >
                            <option key={-1} value={-1}></option>
                            {
                                field.options.map((object, i) => {
                                    return (
                                        <option key={i} value={object.value}>
                                            {object.name}
                                        </option>
                                    );
                                })
                            }
                        </select>
                        <label className="error">{touched ? error : ''}</label>
                    </div>
                );
            case 'selectCompanyAutocomplete':
                return (
                    <div className="form-group">
                        <label htmlFor={field.name}>{field.label}</label>
                        <CompanyAutocomplete
                            company={field.company}
                            id={field.input.name}
                            onlyActive={field.onlyActive}
                            onChange={(value) => {
                                if ( value && value[0] ) {
                                    field.input.onChange(value[0].id);
                                    if ( field.onChangeCompany ) {
                                        field.onChangeCompany(value[0]);
                                    }
                                } else {
                                    field.input.onChange(null);
                                }
                            }}
                        />
                        <label className="error">{touched ? error : ''}</label>
                    </div>
                );
            case 'radio':
                return (
                    <span>
                        {
                            field.radios.map((object, i) => {
                                return (
                                    <span key={i}>
                                    <input
                                        name={field.name}
                                        type="radio"
                                        id={object.name}
                                        className="radio-col-blue-grey"
                                        {...field.input}
                                    />
                                    <label htmlFor={object.name}>
                                        {object.value}-{object.name}
                                    </label>
                                </span>
                                );
                            })
                        }
                        <div className="text-error">{touched ? error : ''}</div>
                    </span>
                );
            case 'submit':
                return (
                    <button
                        test-id="form-submit"
                        type="submit"
                        className="btn btn-lg btn-block btn-primary waves-effect form-btn"
                        disabled={field.disabled || false}
                    >{field.label}</button>
                );
            case 'button':
                return (
                    <button
                        type="button"
                        onClick={field.onClick}
                        className="btn btn-lg btn-block btn-primary waves-effect form-btn"
                        disabled={field.disabled || false}
                    >{field.label}</button>
                );
            default:
                let label = '';
                if ( field.label !== undefined ) {
                    label = <label htmlFor={field.name}>{field.label}</label>;
                }
                return (
                    <div className={'form-group'}>
                        <div className={formLineClassName}>
                            {label}
                            <input
                                test-id={testId}
                                id={field.name}
                                type={field.type}
                                className="form-control"
                                placeholder={field.placeholder}
                                {...field.input}
                                disabled={field.disabled || false}
                                readOnly={field.readOnly || false}
                                onBlur={(event) => {
                                    event.target.value = String(event.target.value).trim();
                                    field.input.onChange(event);
                                }}
                            />
                        </div>
                        <label className="error">{touched ? error : ''}</label>
                    </div>
                );
        }
    }

    render() {
        const { field } = this.props;

        return (
            <div className={field.colWidth}>
                {this.renderField(field)}
            </div>
        );
    }

}

FormField.propTypes = {
    field: PropTypes.objectOf(PropTypes.any).isRequired,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/FormField.js